import { driver } from '@leagueplatform/masonry';
import {
  MASONRY_NAMESPACES,
  MASONRY_WIDGET_TYPES,
  MASONRY_ACTION_TYPES,
} from 'common/constants/masonry';
import { RefillScoreCard } from 'components/refill-score/renderers/refill-score-card.renderer';
import { LearnMoreHeader } from 'components/masonry-renderers/learn-more-header.component';
import { RefillScoreLearnMoreDescription } from 'components/refill-score/refill-score-learn-more-definition.component';
import { RefillScoreBadgeImageSummary } from 'components/refill-score/renderers/refill-score-badge-image-summary.renderer';
import { PageHeaderRenderer } from 'components/masonry-renderers/page-header.renderer';

export const initRefillScoreRegistry = () => {
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.SIMPLE_BADGE_CARD,
    MASONRY_NAMESPACES.REFILL_SCORE,
    RefillScoreCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.LEARN_MORE_HEADER,
    MASONRY_NAMESPACES.REFILL_SCORE,
    LearnMoreHeader,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.LEARN_MORE.HEADER,
    MASONRY_NAMESPACES.REFILL_SCORE,
    LearnMoreHeader,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.LEARN_MORE_DEFINITION,
    MASONRY_NAMESPACES.REFILL_SCORE,
    RefillScoreLearnMoreDescription,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.LEARN_MORE_DEFINITION,
    MASONRY_NAMESPACES.DEFAULT,
    RefillScoreLearnMoreDescription,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.BADGE_IMAGE_SUMMARY,
    MASONRY_NAMESPACES.REFILL_SCORE,
    RefillScoreBadgeImageSummary,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.EXTRA_SMALL_CARD,
    MASONRY_NAMESPACES.REFILL_SCORE_DETAILS,
    driver.nodeRendererRegistry.nodeRenderers.default.extraSmallCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.SMALL_CARD,
    MASONRY_NAMESPACES.REFILL_SCORE,
    driver.nodeRendererRegistry.nodeRenderers.default.smallCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.PAGE_HEADER,
    MASONRY_NAMESPACES.REFILL_SCORE_DETAILS,
    PageHeaderRenderer,
  );

  // ACTIONS
  driver.actionController.registerHandler(
    MASONRY_ACTION_TYPES.DEEPLINK,
    MASONRY_NAMESPACES.REFILL_SCORE_DETAILS,
    () => {},
  );

  driver.actionController.registerHandler(
    MASONRY_ACTION_TYPES.DEEPLINK,
    MASONRY_NAMESPACES.REFILL_SCORE,
    () => {},
  );
};
